import React, { Component, Fragment } from 'react';
import {connect} from 'react-redux';
import history from '../../../../../history';
import { CONFIG, CONFIG_API_BE, URL_AKM} from '../../../../../config';
import {cekCookies} from '../../../../../actions';
import __ from 'lodash';
import LoaderModal from '../../../../modal/LoaderModal';
import Navbar from '../../../navbar/Navbar';
import Sidebar from '../../../sidebar/Sidebar';
import Loader from '../../../../Loader';
import eduprimeApi from '../../../../../apis/eduprimeApi';
import akmApi from '../../../../../apis/akmApi';

import ListPaketProgram from './ListPaketProgram';
import ModalCreateUpdate from './ModalCreateUpdate';
import PaketProgramEntity from '../../../../../entity/PaketProgramEntity';

import {Button, FormControlLabel, Checkbox, TextField, Grid} from '@material-ui/core';
import { Row, Col, Modal } from 'react-bootstrap';
import { MuiPickersUtilsProvider,KeyboardDateTimePicker } from "@material-ui/pickers";
import Autocomplete from '@material-ui/lab/Autocomplete';
import DateFnsUtils from '@date-io/date-fns';
import Snackbar from '@material-ui/core/Snackbar'
import Alert from '@material-ui/lab/Alert';


class PaketProgram extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isFetching: false,
            isSnackbar: false,
            message: null,
            listKelasGroup: [],
            paketProgramEnty: PaketProgramEntity,
            responseListPaketProgram: [],
            isOpen : false,
        }
    }


    async componentDidMount(){
        await this.props.cekCookies();
        if(!__.isEmpty(this.props.account)) {
            this.fetchKelasGroup();
        }     
    }

    fetchKelasGroup = async () =>{
        if(__.isEmpty(this.state.listKelasGroup)){
            const respons = await akmApi.get(URL_AKM.KELAS_GROUP_ALL, {})

            if(respons.data.errorSchema.errorCode === URL_AKM.SUCCESS_ERROR_CODE){
                const dataKelas = {value : '', label: 'Pilih Kelas Group...', id:'idKelasGroup', selected: 'selected'}
                this.state.listKelasGroup.push(dataKelas);
                respons.data.data.map((val, i)=>{
                    const dataKelas = {value : val.idKelasGroup, label: val.namaKelasGroup, id:'idKelasGroup'}
                    this.state.listKelasGroup.push(dataKelas);
                })
            }
        }
    }

    handleOpenModal = async () =>{
        this.setState({isOpen: true});
    }

    handleCloseModal = async () =>{
        this.setState({
            isOpen: false,
            paketProgramEntity: {}
        });
    }

    handleAddJadwal = async (detailPaketProgram) =>{
        history.push({
            pathname: '/mgtjadwalprogram',
            state: {
                detailPaketProgram: detailPaketProgram
            } 
        })
    }

    handleThrowPaketProgram = async (paketProgramThrow) =>{
        console.info('throw', paketProgramThrow)
        this.setState({
            isOpen: true,
            paketProgramEnty: paketProgramThrow,
            isEidupay: paketProgramThrow.isEidupay == 0 ? false : true,
            isUssSbmptn: paketProgramThrow.ussSbmptn == 0 ? false : true,
        });
    }


    render() { 
        const {isFetching, isOpen} = this.state;
        return (
            <div className="wrapper">
                <LoaderModal isFetching={isFetching} />
                <Sidebar account={this.props.account}/>
                <div id="content" style={{paddingBottom: '50px'}}>
                    {this.loadSnackbar()}
                    <Navbar title={"Mgt Paket Program"}/>
                    {this.modalCreateUpdate()}
                    {!isOpen &&
                    <ListPaketProgram 
                        handleCloseModal={this.handleCloseModal}
                        handleOpenModal={this.handleOpenModal}
                        handleThrowPaketProgram={this.handleThrowPaketProgram}
                        handleAddJadwal={this.handleAddJadwal}
                    />
                    }
                </div>
            </div>
        );
    }


    /**======================== MODAL CREATE UPDATE ========================**/

    modalCreateUpdate(){
        const setFree = [
            { label: 'ALL', value: 'ALL' },
            { label: 'PSEP', value: 'PSEP' },
            { label: 'PREMIUM', value: 'PREMIUM' },
            { label: 'PAID ONLY', value: 'PAID' },
        ]; 

        const {paketProgramEnty, listKelasGroup, isEidupay, isUssSbmptn, isOpen} = this.state;

        return (
            <Row>
                <Col>
                    <Modal 
                        show={isOpen}
                        onHide={() => this.handleCloseModal()}
                        aria-labelledby="example-custom-modal-styling-title"
                        size="lg" backdrop="static" keyboard={false}>
                        <Modal.Header>
                            <Modal.Title>Paket Program</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <form onSubmit={this.handleSubmit}>
                                <Grid
                                  container
                                  spacing={2}
                                  direction="column"
                                  justifyContent="flex-start"
                                  alignItems="stretch">
                                    <Grid item xs={12}>
                                        <TextField
                                            required
                                            id="namaProgram"
                                            label="Nama Paket Program"
                                            type="text"
                                            value={paketProgramEnty.namaProgram ? paketProgramEnty.namaProgram : paketProgramEnty.namaProgram}
                                            onChange={this.handleOnChangeInput}
                                        />
                                    </Grid>

                                    <Grid item xs={12} 
                                        container
                                        spacing={2}
                                        direction="row"
                                        justifyContent="space-between"
                                        alignItems="flex-start">
                                            <Grid item xs={6}>
                                                <MuiPickersUtilsProvider utils={DateFnsUtils} id="startedDate">
                                                    <KeyboardDateTimePicker   
                                                        value={paketProgramEnty.startedDate ? paketProgramEnty.startedDate : paketProgramEnty.startedDate} 
                                                        onChange={this.handleOnChangeStartDate}        
                                                        label="Paket Mulai"
                                                        onError={console.log}
                                                        ampm={false}
                                                        format="dd-MM-yyyy HH:mm" required
                                                    />
                                                </MuiPickersUtilsProvider>
                                            </Grid>
                                            <Grid item xs={6}>
                                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                    <KeyboardDateTimePicker   
                                                        value={paketProgramEnty.expiredDate ? paketProgramEnty.expiredDate : paketProgramEnty.expiredDate}
                                                        onChange={this.handleOnChangeEndDate}        
                                                        label="Paket Selesai"
                                                        onError={console.log}
                                                        ampm={false}
                                                        format="dd-MM-yyyy HH:mm" required
                                                    />
                                                </MuiPickersUtilsProvider>
                                            </Grid>
                                    </Grid>

                                    <Grid item xs={12} 
                                        container
                                        spacing={2}
                                        direction="row"
                                        justifyContent="space-between"
                                        alignItems="flex-start">
                                            <Grid item xs={4}>
                                                <Autocomplete                                                    
                                                    id="setFree"
                                                    options={setFree}
                                                    // value={paketProgramEnty.setFree ? paketProgramEnty.setFree : paketProgramEnty.setFree}
                                                    onChange={this.handleOnChangeInput}
                                                    disableClearable
                                                    getOptionLabel={(option) => option.label}
                                                    getOptionDisabled={(option) => 
                                                        option === setFree[0] || 
                                                        option === setFree[1] || 
                                                        option === setFree[2]
                                                    }
                                                    value={
                                                        paketProgramEnty.setFree !== null
                                                            ? setFree.find(
                                                                (x) => x.value === paketProgramEnty.setFree
                                                            )
                                                            : paketProgramEnty.setFree
                                                    }
                                                    renderInput={(params) => (
                                                        <TextField {...params} label="Pilih Set Free" required/>
                                                    )}
                                                />
                                            </Grid>
                                            <Grid item xs={4}>
                                                <Autocomplete                                                    
                                                    id="idKelasGroup"
                                                    options={listKelasGroup}
                                                    onChange={this.handleOnChangeInput}
                                                    disableClearable
                                                    getOptionLabel={(option) => option.label}
                                                    value={
                                                        paketProgramEnty.idKelasGroup !== null
                                                            ? listKelasGroup.find(
                                                                (x) => x.value === paketProgramEnty.idKelasGroup
                                                            )
                                                            : paketProgramEnty.idKelasGroup
                                                    }
                                                    renderInput={(params) => (
                                                        <TextField {...params} label="Pilih Kelas Group" required/>
                                                    )}
                                                />
                                            </Grid>
                                            <Grid item xs={4}>
                                                <TextField
                                                    required
                                                    id="harga"
                                                    label="Harga " 
                                                    type="number"
                                                    value={paketProgramEnty.harga ? paketProgramEnty.harga : paketProgramEnty.harga}
                                                    onChange={this.handleOnChangeInput}
                                                />
                                            </Grid>
                                    </Grid>

                                    <Grid item xs={12} 
                                        container
                                        spacing={2}
                                        direction="row">
                                        <Grid item>
                                            <FormControlLabel
                                                control={<Checkbox checked={isEidupay} onChange={this.handleOnChangeInput} id="isEidupay" />}
                                                label="Eidupay"
                                            />
                                            
                                        </Grid>
                                        <Grid item>
                                            <FormControlLabel
                                                control={<Checkbox checked={isUssSbmptn} onChange={this.handleOnChangeInput} id="isUssSbmptn" />}
                                                label="uss Sbmptn"
                                            />
                                        </Grid>
                                    </Grid>
                                  
                                    <Grid item xs={12}>
                                        <Button variant="outlined" color="secondary" style={{float: 'left'}} onClick={() => this.handleCloseModal()}>
                                            <li className="fa fa-close"> Batal</li>
                                        </Button>
                                        <Button variant="outlined" color="primary" type="submit" style={{float: 'right'}}>
                                            <li className="fa fa-save"> Simpan</li>
                                        </Button>
                                    </Grid>
                                </Grid>
                            </form>
                        </Modal.Body>
                    </Modal>
                </Col>
            </Row>
        );
    }

    handleOnChangeInput = (e, value, reason) =>{
        const id = e.target.id;
        const val = e.target.value;

        if(reason === 'select-option'){

            const idSplit = id.split('-');

            this.setState(prevState => ({     
                paketProgramEnty: {
                    ...prevState.paketProgramEnty,
                    [idSplit[0]]: value.value
                }            
            }))

        }else{
            if(id == 'isEidupay'){
                this.setState({isEidupay : !this.state.isEidupay});
                this.setState(prevState => ({     
                    paketProgramEnty: {
                        ...prevState.paketProgramEnty,
                        isEidupay: !this.state.isEidupay ? 1 : 0
                    }            
                }))

            }else if(id == 'isUssSbmptn'){
                this.setState({isUssSbmptn : !this.state.isUssSbmptn});
                this.setState(prevState => ({     
                    paketProgramEnty: {
                        ...prevState.paketProgramEnty,
                        ussSbmptn: !this.state.isUssSbmptn ? 1 : 0
                    }            
                }))

            }else {
                this.setState(prevState => ({     
                    paketProgramEnty: {
                        ...prevState.paketProgramEnty,
                        [id]: val
                    }            
                }))
            }
            

        }        
    }

    handleOnChangeStartDate  = (date) => {        
        this.setState(prevState => ({     
            paketProgramEnty: {
                ...prevState.paketProgramEnty,
                startedDate: date
            }            
        }))
    }

    handleOnChangeEndDate = (date) => {        
        this.setState(prevState => ({     
            paketProgramEnty: {
                ...prevState.paketProgramEnty,
                expiredDate: date
            }            
        }))
    }

    handleSubmit = async (e) =>{
        e.preventDefault();
        const {paketProgramEnty} = this.state;
        var response = "";
        
        if(paketProgramEnty.idPaketProgram == null){
            response = await akmApi.post(URL_AKM.SIMPAN_PAKET_PROGRAM, paketProgramEnty
            ).catch(function(error){
                this.setState({error})
            })
        }else{
            response = await akmApi.put(URL_AKM.SIMPAN_PAKET_PROGRAM + paketProgramEnty.idPaketProgram, paketProgramEnty
            ).catch(function(error){
                this.setState({error})
            })
        }
        
        if(response.data.data){
            this.handleCloseModal();

        }
        
    }

    handleCloseModal = async () => {
        this.setState({ 
            isOpen: false, 
            paketProgramEnty: {}
        })
    }

    loadSnackbar = () => {
        const {isSnackbar, codeError, message } = this.state;      
        return (
            <Snackbar
                anchorOrigin={{
                vertical: '',
                horizontal: '',
                }}                
                open={isSnackbar}
                autoHideDuration={5000} 
                onClose={() => this.setState({ isSnackbar: false })}>
                <Alert onClose={() => this.setState({ isSnackbar: false })} severity={codeError == 'EP-000' ? 'success' : 'error'}>
                    <b>{message}</b>
                </Alert>
            </Snackbar>
        );
    }
}
 
const mapStateToProps = (state) => {
    return{
        account: state.account       
    };
}

export default connect(mapStateToProps, {cekCookies})(PaketProgram);